/**
 * Shared timeline clock so UI indicator + object animation loops
 * stay in sync when playback rate changes (FF / reverse).
 */
const clock = {
  rate: 1,
  anchorTime: 0,
  anchorWallMs: Date.now(),
};

export function getTimelinePlaybackRate() {
  return clock.rate;
}

export function getTimelinePlaybackTime() {
  const elapsedSec = (Date.now() - clock.anchorWallMs) / 1000;
  return clock.anchorTime + elapsedSec * clock.rate;
}

export function seekTimelinePlayback(timeSec) {
  clock.anchorTime = Math.max(0, Number(timeSec) || 0);
  clock.anchorWallMs = Date.now();
}

export function setTimelinePlaybackRate(rate) {
  const next = Number(rate);
  if (!Number.isFinite(next) || next === 0) return clock.rate;
  // Rebase so speed changes don't jump the playhead
  clock.anchorTime = getTimelinePlaybackTime();
  clock.anchorWallMs = Date.now();
  clock.rate = next;
  return clock.rate;
}

export function resetTimelinePlaybackClock(timeSec = 0, rate = 1) {
  clock.rate = Number.isFinite(rate) && rate !== 0 ? rate : 1;
  clock.anchorTime = Math.max(0, Number(timeSec) || 0);
  clock.anchorWallMs = Date.now();
}

/** Forward button: 1x → 2x → 4x → 8x (from reverse, jump to 1x). */
export function nextForwardPlaybackRate(currentRate = clock.rate) {
  const rate = Number(currentRate) || 1;
  if (rate < 1) return 1;
  if (rate < 2) return 2;
  if (rate < 4) return 4;
  return 8;
}

/** Back button: enter reverse −1x → −2x → −4x → −8x. */
export function nextBackwardPlaybackRate(currentRate = clock.rate) {
  const rate = Number(currentRate) || 1;
  if (rate > 0) return -1;
  if (rate > -2) return -2;
  if (rate > -4) return -4;
  return -8;
}
